<template>
    <div class="my-4 flex h-auto w-full flex-col items-center justify-start md:hidden">
        <div class="flex h-10 w-full items-center justify-between">
            <p class="text-lg font-semibold text-primary-500">{{ currentStep?.label }}</p>
            <p>Step {{ currentStepNumber }} of {{ steps.length }}</p>
        </div>
        <div class="h-2 w-full overflow-hidden rounded-lg bg-gray-200">
            <div
                class="h-full rounded-lg bg-primary-500 duration-150"
                :style="{ width: `${(currentStepNumber / steps.length) * 100}%` }"></div>
        </div>
        <div class="relative flex h-10 w-full items-center justify-center space-x-1">
            <ChevronLeftIcon
                v-if="currentStepIndex > 0"
                class="absolute left-0 w-6 text-primary-500"
                @click="navigateToStep(steps[currentStepIndex - 1])" />
            <div
                v-for="step in steps"
                :key="step.name"
                class="h-3 w-3 rounded-full"
                :class="{ 'bg-gray-400': step.name !== pageKey, 'bg-primary-500': step.name === pageKey }"></div>
            <ChevronRightIcon
                v-if="
                    currentStepIndex < steps.length &&
                    pendingInvestment.step &&
                    currentStepIndex < pendingInvestment.step
                "
                class="absolute right-0 w-6 text-primary-500"
                @click="navigateToStep(steps[currentStepIndex + 1])" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { InvestmentStep, useInvestmentProcessNavigation } from '../../utilities/account/useInvestmentProcessNavigation'
import { storeToRefs } from 'pinia'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/outline'
import { getPendingInvestmentCookie } from '../../utilities/investment-process/usePendingInvestmentProcess'

const navigationStore = useInvestmentProcessNavigation()
const { steps, pageKey } = storeToRefs(navigationStore)
const pendingInvestment = getPendingInvestmentCookie()

const currentStep = ref<InvestmentStep | null>(null)
const currentStepNumber = computed(() => {
    return steps.value.findIndex((step) => step.name === pageKey.value) + 1
})
const currentStepIndex = computed(() => {
    return steps.value.findIndex((step) => step.name === pageKey.value)
})

const navigateToStep = (step: InvestmentStep) => {
    pageKey.value = step.name as string
}

watch(pageKey, (newPageKey) => {
    currentStep.value = steps.value.find((step) => step.name === newPageKey) as InvestmentStep
    window.scrollTo({ top: 0, behavior: 'smooth' })
})

onMounted(() => {
    if (pendingInvestment.step) {
        currentStep.value = steps.value[pendingInvestment.step]
    } else {
        currentStep.value = steps.value[0]
    }
})
</script>
